<template lang="html">
  <div class="rules-wrapper-background">
    <div class="page-help content">
      <div class="rules">{{ $t("newFranchise.rules") }}</div>
      <div class="table">
        <div class="row th">
          <td>{{ $t("main.documentName") }}</td>
          <div class="action">
            <td>{{ $t("newFranchise.read") }}</td>
            <td>{{ $t("newFranchise.download") }}</td>
          </div>
        </div>

        <div v-for="(doc, index) in documents" :key="index" class="row tr">
          <div style="display: flex;">
            <td>
              <div class="icon-wrapper">
                <img
                  v-if="doc.doc_priority === 2"
                  src="@/assets/icons/importantDocument.png"
                  alt="preview icon"
                />
              </div>
            </td>
            <td>{{ doc.doc_name }}</td>
          </div>
          <div class="action">
            <td v-if="doc.doc_type !== 'DOC'">
              <a class="link" :href="generatePreviewLink(doc)" target="_blank">
                <div class="icon-wrapper">
                  <img
                    src="@/assets/icons/previewDocument.png"
                    alt="preview icon"
                  />
                </div>
              </a>
            </td>
            <td v-else></td>
            <td>
              <a class="link" :href="generateDownloadLink(doc)">
                <div class="icon-wrapper">
                  <img
                    src="@/assets/icons/downloadDocument.png"
                    alt="preview icon"
                  />
                </div>
              </a>
            </td>
          </div>
        </div>
        <!-- end files -->
      </div>
      <!-- end table -->
    </div>
  </div>
</template>

<script>
import { api, baseURL } from "@/api";
export default {
  name: "Rules",
  data() {
    return {
      documents: []
    };
  },
  mounted() {
    this.fetchRules();
  },
  methods: {
    fetchRules() {
      api
        .fetchRules()
        .then(res => {
          console.log(res);
          this.documents = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    generatePreviewLink(doc) {
      return baseURL + `/documents/${doc.doc_id}/document`;
    },
    generateDownloadLink(doc) {
      return baseURL + `/documents/${doc.doc_id}/download`;
    }
  },
  watch: {
    "$i18n.locale": {
      handler(newLocale, oldLocale) {
        if (newLocale !== oldLocale) {
          this.fetchRules();
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.rules-wrapper-background {
  background-color: $gray-blue-100;
  width: 100%;
  font-family: Outfit;
  text-align: left !important;
  padding: 113px 109px;
}

.content {
  text-align: left;

  .rules {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 36px;
    line-height: 66px;
    letter-spacing: 0%;
    color: $blue-1000;
    margin-bottom: 30px;
  }
  .rules-txt {
    font-weight: 600;
    font-style: SemiBold;
    font-size: 20px;
    line-height: 32px;
    letter-spacing: 0%;
    color: $blue-1000;
    margin-bottom: 56px;
    max-width: 1240px;
  }
  .row,
  .action,
  td {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .action {
    width: 15%;
    min-width: 155px;
    td {
      width: 50%;
      display: flex;
      justify-content: center;
    }
  }

  .th {
    padding: 24px;
    td {
      box-sizing: border-box;
      text-align: left;

      border: none;
      font-weight: 500;
      font-style: Medium;
      font-size: 20px;
      line-height: 30px;
      letter-spacing: 0%;
      color: $gray-blue-1300;
    }
  }

  .tr {
    margin-bottom: 20px;
    border: 1px solid #e8e8e8;
    border-radius: 11px !important;
    padding: 24px;
    background-color: $gray-blue-100;
    td {
      box-sizing: border-box;
      text-align: left;

      font-weight: 400;
      font-style: Regular;
      font-size: 25px;
      line-height: 100%;
      letter-spacing: 0%;

      .icon-wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
      }
    }
  }
  // .tr:last-child {
  //   td {
  //     border-bottom: none;
  //   }
  // }
}

// @media only screen and (max-width: 1200px) {
//   .content {
//     margin: auto;
//   }
// }

@media only screen and (max-width: 750px) {
  .rules-wrapper-background {
    padding: 50px 40px;
  }
  .content {
    .rules {
      font-size: 36px;
      line-height: 46px;
      margin-bottom: 30px;
    }
    .rules-txt {
      font-size: 18px;
      line-height: 26px;
      margin-bottom: 56px;
    }
    .th,
    .tr {
      padding: 14px;
    }
    .th {
      td {
        font-size: 16px;
        line-height: 20px;
      }
    }

    .tr {
      margin-bottom: 15px;

      td {
        font-weight: 400;
        font-style: Regular;
        font-size: 16px;
        line-height: 20px;
      }
    }
  }
}
</style>
